module.exports = {
  __init__: [ 'rules' ],
  rules: [ 'type', require(226) ]
};
